import React from "react";

import '../Style.css';

import { IoIosSend } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { BiRightTopArrowCircle } from "react-icons/bi";

import currency_counter from '../Assets/Images/Economic Scales/Cash counting machine/currency_counter.jpg';
import semivalue_counting from '../Assets/Images/Economic Scales/Cash counting machine/semivalue_counting.jpg';
import value_counting from '../Assets/Images/Economic Scales/Cash counting machine/value_counting.png';


function Cashcountingmachine() {
    return (
        <div>


            <section className="py-5">
                <div className="container py-lg-5">
                    <div class="mt-3">
                        <p class="section-top-heading-css py-3 py-lg-0">Cash Counting Machine</p>

                    </div>
                    <div className="row   row-cols-lg-3 row-cols-1  justify-content-center g-4 align-items-center ">

                        <div className="col text-center">
                            <div className="about-small-card-css card h-100 p-4">
                                <div className="text-center image-stretch-css">
                                    <img className="product-swiper-image" src={currency_counter} />
                                </div>
                                <p className="about-card-heading-css text-center">
                                    Currency Counting Machine
                                </p>
                                {/* <p className="about-card-para-css">Capacity : </p>
                                <p className="about-card-para-css">Accuracy : </p>
                                <p className="about-card-para-css">Platter Size ( mm ) : </p> */}
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    {/* <div className="col">
                                        <a href="/" className="" >
                                            <button className="btn CTA-button-css-2">
                                                <span className="underline_text ">Know More</span> <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div> */}
                                </div>

                            </div>
                        </div>

                        <div className="col text-center">
                            <div className="about-small-card-css card h-100 p-4">
                                <div className="text-center image-stretch-css">
                                    <img className="product-swiper-image" src={semivalue_counting} />
                                </div>
                                <p className="about-card-heading-css text-center">
                                    Semivalue Counting Machine
                                </p>
                                {/* <p className="about-card-para-css">Capacity : </p>
                                <p className="about-card-para-css">Accuracy : </p>
                                <p className="about-card-para-css">Platter Size ( mm ) : </p> */}
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    {/* <div className="col">
                                        <a href="/" className="" >
                                            <button className="btn CTA-button-css-2">
                                                <span className="underline_text ">Know More</span> <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div> */}
                                </div>

                            </div>
                        </div>

                        <div className="col text-center">
                            <div className="about-small-card-css card h-100 p-4">
                                <div className="text-center image-stretch-css">
                                    <img className="product-swiper-image" src={value_counting} />
                                </div>
                                <p className="about-card-heading-css text-center">
                                    Currency Counting Machine
                                </p>
                                {/* <p className="about-card-para-css">Capacity : </p>
                                <p className="about-card-para-css">Accuracy : </p>
                                <p className="about-card-para-css">Platter Size ( mm ) : </p> */}
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    {/* <div className="col">
                                        <a href="/" className="" >
                                            <button className="btn CTA-button-css-2">
                                                <span className="underline_text ">Know More</span> <BiRightTopArrowCircle className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div> */}
                                </div>

                            </div>
                        </div>

                    </div>


                </div>
            </section>


        </div >

    );
}

export default Cashcountingmachine;
